import { combineReducers } from 'redux';
import api from './api';
import business from './business';
import businesses from './businesses';
import config from './config';
import submission from './submission';

export default combineReducers({
  api,
  business,
  businesses,
  config,
  submission,
});
